import BotaoEnviaJson from './BotaoEnviaJson'
import enhance from './BotaoEnviaJson.enhancer'

export default enhance(BotaoEnviaJson)



// WEBPACK FOOTER //
// ./src/routes/sistema/OkReportDeveloper/components/BotaoEnviaJson/index.js